import TaxSocialSecurityLimitsPage from '@playground/features/dictionary/TaxSocialSecurityLimitsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_app/_superAdmin/dictionary/tax-social-security-limits'
)({
  component: TaxSocialSecurityLimitsPage,
})
